import axios from "axios";
import { getHeaders, getURl } from "./core";

export function getOvertimeReport({ date, search = "", isExport = false }) {
  const result = axios({
    method: 'GET',
    headers: getHeaders(),
    url: `${getURl()}/reports/v1/overtimes?rangFilter=${date}&search=${search}&isExport=${isExport}`
  });
  return new Promise((resolve, reject) => {
    result
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
}